import { WebAppProject } from "../project/WebAppProject";
import { WebAppComponent } from "../WebAppComponent";

export class AppCommandContext<C, P extends WebAppProject> extends WebAppComponent<C,P>
{
  
}